export default __webpack_public_path__ + "static/media/BrakeMaintenance2.d51fc1f9.png";